var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_5021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5031 1.00488C25.3393 1.00488 32.5031 7.65836 32.5031 16.4963C32.5031 25.3341 25.3393 32.4988 16.5031 32.4988C7.66685 32.4988 0.503906 25.3341 0.503906 16.4963C0.503906 7.65836 7.66685 1.00488 16.5031 1.00488Z",
    fill: "#4B4F57"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_657_5021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8833 17.2111C25.9732 17.1725 26.0498 17.1084 26.1037 17.0267C26.1575 16.9449 26.1862 16.8492 26.1861 16.7513C26.1861 16.6534 26.1573 16.5577 26.1033 16.4761C26.0494 16.3944 25.9727 16.3304 25.8827 16.2919L11.4826 10.1214L11.4815 10.1203L11.0346 9.92793C10.9499 9.89174 10.857 9.87961 10.7659 9.89289C10.6748 9.90617 10.5891 9.94434 10.5183 10.0032C10.4476 10.062 10.3944 10.1393 10.3647 10.2264C10.335 10.3135 10.33 10.4072 10.3501 10.497L10.4559 10.9705L10.4553 10.9733L11.74 16.7518L10.4553 22.5314L10.4559 22.5342L10.3495 23.0083C10.3297 23.098 10.3351 23.1915 10.3649 23.2785C10.3948 23.3654 10.4481 23.4424 10.5189 23.5011C10.5897 23.5597 10.6753 23.5977 10.7662 23.6109C10.8572 23.624 10.9501 23.6118 11.0346 23.5757L25.8833 17.2111ZM23.2506 17.2519L24.4164 16.7512L23.2506 16.2517L12.6524 16.2512L12.739 16.6432C12.7554 16.7147 12.7554 16.7889 12.739 16.8604L12.653 17.2519L23.2506 17.2519Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_5021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.503906 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_657_5021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(15.0801 3.17578) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTelegramIcon);
export default __webpack_public_path__ + "static/media/circleTelegramIcon.81615015dcc722be7978bc52742ad229.svg";
export { ForwardRef as ReactComponent };